<template>
    <div class="wf-pageMobile">
        <div class="wf-pageMobile-title">{{title}}</div>
        <div class="wf-pageMobile-search" ref="">
            <div :class="`wf-pageMobile-search-item wf-pageMobile-search-item-${searchItem.type} ${searchItem.isRowEnd ? 'wf-pageMobile-search-item-rowEnd' : ''}`" v-for="(searchItem, searchKey) in renderSearchList" :key="searchKey">
                <div class="wf-pageMobile-search-rangePicker" v-if="searchItem.type === 'rangePicker'  && !searchItem.isHide">
                    <RangePicker :maxEndDate="searchItem.maxEndDate" :minStartDate="searchItem.minStartDate" :maxInterval="searchItem.maxInterval" v-model="searchData[searchItem.key]" @change="handleChange"></RangePicker>
                </div>

                <div class="wf-pageMobile-search-picker" v-if="searchItem.type === 'picker' && !searchItem.isHide">
                    <Picker :style="searchItem.style" :valueKey="searchItem.valueKey" v-model="searchData[searchItem.key]" :label="searchItem.label" :options="searchItem.options" @change="handleChange"></Picker>
                </div>

                <div class="wf-pageMobile-search-input" v-if="searchItem.type === 'input'  && !searchItem.isHide">
                    <Input :style="searchItem.style" v-model="searchData[searchItem.key]" :label="searchItem.label" @change="handleChange"></Input>
                </div>
            </div>

            <div class="wf-pageMobile-search-btn" @click="handleSearch">查询</div>
            <div v-if="showDownload" class="wf-pageMobile-search-btn wf-pageMobile-search-btn-download" @click="handleDownload">{{downloadText}}</div>

            <div v-if="showAdd" :class="`wf-pageMobile-search-btn wf-pageMobile-search-btn-add ${disabledAdd ? 'wf-pageMobile-search-btn-disabled' : ''}`" @click="handleAdd">
                <img src="../image/search/add.png" alt="">
                <span>{{addText}}</span>
            </div>
        </div>

        <div class="wf-pageMobile-content">
            <slot></slot>
        </div>

        <div class="wf-pageMobile-pagination" >
            <!-- <Page :current="current" :total="total" :page-size="pageSize" @on-change="handleChangeCurrent"></Page> -->
            <Pagination v-if="total > 0" v-model="componentCurrent" :show-page-size="3" force-ellipses :total-items="total" :items-per-page="pageSize" @change="handleChangeCurrent">
                <template #prev-text>
                    <Icon color="#B4B4B4" style="transform: rotate(180deg)" name="play" />
                </template>
                <template #next-text>
                    <Icon color="#B4B4B4" name="play" />
                </template>
            </Pagination>
        </div>
    </div>
</template>

<script>
import RangePicker from '@/components/rangePicker/rangePicker.vue'
import Picker from '@/components/picker/picker.vue'
import Input from '@/components/inputMobile/inputMobile.vue'
import Pagination from 'vant/lib/pagination';
import Icon from 'vant/lib/icon';
import 'vant/lib/pagination/style'
import 'vant/lib/icon/style'

export default {
	components: {
		Icon,
        Input,
        Picker,
        RangePicker,
        Pagination
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        renderSearchList: {
            type: Array,
            default: () => {
                return []
            }
        },
        searchData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        current: {
            type: Number,
            default: 1
        },
        total: {
            type: Number,
            default: 0
        },
        pageSize: {
            type: Number,
            default: 0
        },
        showDownload: {
            type: Boolean,
            default: false
        },
        downloadText: {
            type: String,
            default: "导出"
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        addText: {
            type: String,
            default: ""
        },
        disabledAdd: {
            type: Boolean,
            default: false
        }
    },
    data() {
		return {
			componentCurrent: 0
        }
	},
	mounted() {
		this.componentCurrent = this.current
	},
    methods: {
        // 处理表单数据改变事件
        handleChange() {
            this.$emit('change', this.searchData)
        },

        // 处理当前页改变事件
		handleChangeCurrent(current) {
			this.$emit('changeCurrrent', current)
		},
		
		// 处理搜索时触发
        handleSearch() {
            this.$emit('search')
        },

        // 处理点击下载事件
        handleDownload() {
            this.$emit('download')
        },

        // 处理点击新增按钮时触发
        handleAdd() {
            if (!this.disabledAdd) {
                this.$emit('add')
            }
        }
        
	},
	watch: {
		current(newValue) {
			this.componentCurrent = newValue
		}
	}
}
</script>

<style lang="scss" scoped>
.wf-pageMobile {
    display: flex;
    flex-direction: column;
    position: relative;
	flex: 1;
    //min-height: 100%;
    //height: 100%;
    background-color: #fff;
}
.wf-pageMobile-title {
    position: absolute;
    left: 0;
    top: 0.41rem;
    height: 0.3rem;
    padding-left: 0.26rem;
    font-size: 0.3rem;
    line-height: 0.3rem;
    border-left: 0.06rem solid #005fed;
    color: #333;
}
.wf-pageMobile-search {
    padding: 1.1rem 0.26rem 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 0.4rem;
    .wf-pageMobile-search-item {
        margin-bottom: 0.3rem;
    }
	.wf-pageMobile-search-item-picker {
		width: calc(50% - 0.15rem);
		margin-right: 0.3rem;
		>>>.wf-picker-input {
			flex: 1;
		}
	}
    .wf-pageMobile-search-item-rangePicker {
        width: 100%;
    }
    .wf-pageMobile-search-item-input {
        margin-right: 0.3rem;
        width: calc(50% - 0.15rem);
    }
    .wf-pageMobile-search-item-rowEnd {
        margin-right: 0;
    }
    .wf-pageMobile-search-btn {
        width: 100%;
        height: 0.8rem;
        font-size: 0.3rem;
        line-height: 0.8rem;
        text-align: center;
        border-radius: 0.04rem;
        color: #fff;
        background-color: #046ce8;
    }
    .wf-pageMobile-search-btn-disabled {
        opacity: .3;
    }
    .wf-pageMobile-search-btn-download, .wf-pageMobile-search-btn-add {
        margin-top: .3rem;
    }
    .wf-pageMobile-search-btn-add {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        >img {
            width: 0.26rem;
            height: 0.26rem;
            margin-right: 0.2rem;
        }
    }
}
.wf-pageMobile-content {
    flex: 1;
    padding: 0 0.26rem;
    background-color: #fff;
}

.wf-pageMobile-pagination {
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 0.62rem;
    margin-top: 0.3rem;
	margin-bottom: 0.3rem;
    >>> .van-pagination {
		.van-pagination__item {
			width: 0.62rem;
			min-width: 0.62rem;
			height: 0.62rem;
			margin-right: 0.2rem;
			border: 0.02rem solid #E0E0E0;
			color: #666;
		}
		.van-pagination__item--active {
			background-color: #0061E4;
			border-color: #0061E4;
			color: #fff;
		}
		.van-pagination__item::after {
			border: none;
		}
		.van-pagination__item:active {
			background-color: #0061E4;
			color: #fff;
		}
		.van-pagination__prev:active, .van-pagination__next:active  {
			background-color: #fff;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pageMobile/pageMobile.vue